$(function() {
  if(!$('html.library-texts.index').length) {
    return false;
  }

  $('#content a[data-method="post"]').on('click', function(e) {
    $('#loading-modal').modal('show');
  });

  $('#preview-modal').on('show.bs.modal', function(e) {
    var $target = $(e.relatedTarget);
    var $modal = $(this);
    $modal.find('.modal-title').text($target.data('name'));
    $modal.find('.loading').show();
    $modal.find('.content').hide();
    $.ajax({
      url: $target.attr('href')
    })
      .done(function(data) {
        $modal.find('.loading').hide();
        $modal.find('.content').html(data).show();
      })
      .fail(function() {
        alert('Error loading library text! Sorry about that. Please try again and let us know if you see this error message again.');
      });
  });
});
